import React from 'react';
import {
  FormControl,
  FormControlProps,
  FormErrorMessage,
  FormErrorMessageProps,
  forwardRef,
  Input,
  InputProps,
} from '@chakra-ui/react';

interface ChakraFormBaseInputProps extends InputProps {
  errorMessage?: string;
  formControlProps?: FormControlProps;
  formErrorMessageProps?: FormErrorMessageProps;
}

export const ChakraFormBaseInput = forwardRef(
  (
    {
      errorMessage,
      id,
      isRequired,
      isDisabled,
      isInvalid,
      isReadOnly,
      formControlProps,
      formErrorMessageProps,
      ...rest
    }: ChakraFormBaseInputProps,
    ref
  ) => (
    <FormControl
      variant="unstyled"
      {...{ id, isRequired, isDisabled, isInvalid, isReadOnly }}
      {...formControlProps}
    >
      <Input {...rest} ref={ref} />
      {errorMessage && (
        <FormErrorMessage data-testid="error-text" {...formErrorMessageProps}>
          {errorMessage}
        </FormErrorMessage>
      )}
    </FormControl>
  )
);
